import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import CustomSidebar from './CustomSidebar';
import NotificationBell from '../ui/NotificationBell';
import { ThemeProvider } from '../../contexts/ThemeContext';
import '../../styles/theme.css';

const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Fechar sidebar ao clicar em um link (mobile)
  const closeSidebar = () => {
    if (window.innerWidth < 1024) { // lg breakpoint
      setSidebarOpen(false);
    }
  };

  return (
    <ThemeProvider>
      <div className="flex h-screen main-layout transition-colors overflow-hidden">

      {/* Sidebar */}
      <div className={`
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0
        fixed lg:relative
        inset-y-0 left-0 z-40
        w-64 sm:w-72 lg:w-64
        transition-transform duration-300 ease-in-out
        lg:transition-none
        shadow-2xl lg:shadow-none
      `}>
        <div onClick={closeSidebar}>
          <CustomSidebar />
        </div>
      </div>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-60 z-30 backdrop-blur-sm"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      
      <main className="flex-1 overflow-auto lg:ml-0 w-full min-h-0 flex flex-col">
        {/* Header com notificações - safe-area no topo em smartphone */}
        <div className="header-sticky sticky top-0 z-30 bg-white border-b border-gray-200 px-3 py-2.5 sm:px-4 sm:py-3 lg:px-6 shadow-sm">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-2 sm:gap-4 min-w-0 flex-1">
              {/* Mobile menu button - área de toque 44px */}
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="lg:hidden p-2.5 -ml-1 rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-colors touch-manipulation min-h-[44px] min-w-[44px] flex items-center justify-center"
                aria-label="Abrir ou fechar menu"
              >
                {sidebarOpen ? <X className="h-6 w-6 text-gray-700" /> : <Menu className="h-6 w-6 text-gray-700" />}
              </button>
              {/* Título da página (mobile) */}
              <h2 className="lg:hidden font-semibold text-gray-800 text-base truncate">
                Painel
              </h2>
            </div>
            {/* Notificações - área de toque adequada */}
            <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
              <NotificationBell />
            </div>
          </div>
        </div>
        {/* Conteúdo da página - padding alinhado para mobile */}
        <div className="page-content-wrapper flex-1 p-3 sm:p-4 lg:p-6 max-w-full overflow-x-hidden box-border">
          <Outlet />
        </div>
      </main>
      </div>
    </ThemeProvider>
  );
};

export default Layout;
